// ===================================
// FILE 4: generatedcv.component.ts (UPDATED)
// ===================================

import { Component, OnInit } from '@angular/core';
import { GeneratedcvService } from './services/generatedcv.service';
import { environment } from 'src/environments/environment';
import { EditCV, GeneratedCVModel } from './models/generated-cv-model';
import { Router } from '@angular/router';
import { ImageService } from 'src/app/services/image/image.service';

@Component({
  selector: 'app-generatedcv',
  templateUrl: './generatedcv.component.html',
  styleUrls: ['./generatedcv.component.css'],
})
export class GeneratedcvComponent implements OnInit {
  constructor(
    private generatedcvService: GeneratedcvService,
    private router: Router,
    private imageService: ImageService
  ) {}

  mainURL = 'assets/cvs/';
  imagePath = environment.apiUrl + this.mainURL;
  generatedCvs: GeneratedCVModel[] = [];
  isEditable: boolean = false;
  cvImageUrls: { [key: string]: string } = {};

  // Popup state
  showCoverLetterPopup: boolean = false;
  selectedCvId: string = '';

  ngOnInit(): void {
    this.generatedcvService.getGeneratedCV().subscribe((generatedcv: any) => {
      this.generatedCvs = generatedcv;
      this.loadAllImages();
    });
  }

  loadAllImages() {
    this.generatedCvs.forEach((cv) => {
      if (cv.imagePath) {
        const fullImageUrl = this.imagePath + cv.imagePath;

        this.imageService.getSecureImage(fullImageUrl).subscribe({
          next: (blobUrl) => {
            this.cvImageUrls[cv.imagePath] = blobUrl;
          },
          error: (err) => {
            // console.error('Error loading image:', err);
          },
        });
      }
    });
  }

  getImageUrl(imageLink: string): string {
    return this.cvImageUrls[imageLink] || 'assets/img/placeholder.png';
  }

  downloadFile(path: string) {
    const fullUrl = this.imagePath + path;
    const fileName = path.split('/').pop() || 'download';

    this.imageService.getSecureImage(fullUrl).subscribe({
      next: (blobUrl) => {
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      error: (err) => {
        // console.error('Error downloading file:', err);
      },
    });
  }

  makeOrder(cvId: string, type: string) {
    this.router.navigate(['/payment'], {
      state: {
        productKey: type,
        serviceSystemId: cvId,
      },
      queryParams: {
        productKey: type,
        serviceSystemId: cvId,
      },
    });
  }

  disableRightClick(event: MouseEvent) {
    event.preventDefault();
  }

  // Open the popup when Generate Cover Letter is clicked
  openCoverLetterPopup(cvId: string) {
    this.selectedCvId = cvId;
    this.showCoverLetterPopup = true;
  }

  // Close the popup
  closeCoverLetterPopup() {
    this.showCoverLetterPopup = false;
    this.selectedCvId = '';
  }

  ngOnDestroy() {
    Object.values(this.cvImageUrls).forEach((url) => {
      URL.revokeObjectURL(url);
    });
  }

  backToEdit(cvId: string) {
    this.generatedcvService.editGeneratedCv(cvId).subscribe({
      next: (res) => {
        if (res.valid) {
          let editMode = true;
          let data: any = localStorage.getItem('cvFormData');
          if (data) {
            data = JSON.parse(data);
            data.activeStep = 0;
            let modifiedFormdata = JSON.stringify(data);
            localStorage.setItem('cvFormData', modifiedFormdata);
            localStorage.setItem('activeStep', '0');
          }

          this.router.navigate(['/generatResumeSteps', { cvId, editMode }]);
        }
      },
    });
  }
}
